import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../../../../ui';
import { ConfirmationBookingDetails } from './ConfirmationBookingDetails';
import ContentWrap from '../../../../../ui/components/Layout/ContentWrap';

interface IConfirmationMainProps {
	children: ReactNode;
}

export const ConfirmationMain = ({ children }: IConfirmationMainProps) => (
	<ContentWrap>
		<Grid>
			<GridItem columns={[8, { mobileXL: 12 }]}>
				<MessageWrap>{children}</MessageWrap>
			</GridItem>
			<GridItem columns={[4, { mobileXL: 12 }]}>
				<ConfirmationBookingDetails />
			</GridItem>
		</Grid>
	</ContentWrap>
);

const MessageWrap = styled.div`
	max-width: 588px;
`;
